// Port of api/fuel/app/classes/controller/api/monty/users/filters.php
import DB from 'offline/db'
import Util from 'offline/util'
import { resolveOwner } from 'offline/api/monty'
import F from 'offline/filter/constants'
import User from 'offline/model/user'
import Artist from 'offline/model/artist'
import Category from 'offline/model/category'
import Collection from 'offline/model/collection'
import Designer from 'offline/model/designer'
import Family from 'offline/model/family'
import Game from 'offline/model/game'
import Language from 'offline/model/language'
import Mechanic from 'offline/model/mechanic'
import Play from 'offline/model/play'
import Player from 'offline/model/player'
import Publisher from 'offline/model/publisher'
import Tag from 'offline/model/tag'
import TagFamily from 'offline/model/tag/family'

var MODEL_MAP = {
	artist: Artist,
	category: Category,
	designer: Designer,
	family: Family,
	game: Game,
	language: Language,
	mechanic: Mechanic,
	publisher: Publisher
}

function extractValues(values) {
	var final = []

	for (var i = 0; i < values.length; i++) {
		var parts = String(values[i]).split('-')
		final.push(parts[0])
	}

	return final
}

function normalise(text) {
	return Util.slug(text)
}

function cleanSet(raw) {
	var cleaned = raw.map(function(location) {
		if (location === null || location === undefined) return null

		location = String(location).replace(/\s+/g, ' ').trim()
		location = location.toLowerCase().replace(/\b\w/g, function(match) { return match.toUpperCase() })

		return location || null
	}).filter(Boolean)

	cleaned = cleaned.filter(function(option, index) {
		return cleaned.indexOf(option) === index
	})

	cleaned.sort(function(a, b) {
		return a.toLowerCase().localeCompare(b.toLowerCase())
	})

	return cleaned.map(function(option) {
		return {
			value: Util.slug(option),
			text: option
		}
	})
}

function optionFromRow(name, row) {
	var idField = name + '_id'
	var textField = name + '_name'

	return {
		value: parseInt(row[idField], 10) + '-' + normalise(row[textField]),
		text: row[textField]
	}
}

function modelFilter(name, user, params, returnAll) {
	var data = { options: [] }
	var Model = MODEL_MAP[name]
	var idField = name + '_id'
	var textField = name + '_name'

	if (!Model) return data

	if (params.values && params.values.length) {
		Model.where([[idField, 'in', extractValues(params.values)]]).forEach(function(item) {
			data.options.push(optionFromRow(name, item.rawData()))
		})
		return data
	}

	if (returnAll) {
		var allRows = DB.query('SELECT * FROM ' + Model.schema_table() + ' ORDER BY ' + textField + ' ASC')
		for (var i = 0; i < allRows.length; i++) {
			data.options.push(optionFromRow(name, allRows[i]))
		}
		return data
	}

	var text = params.text || ''
	var rows = DB.query(
		'SELECT * FROM ' + Model.schema_table() + ' WHERE ' + textField + " LIKE ? ORDER BY LENGTH(" + textField + ') ASC, ' + textField + ' ASC LIMIT 100',
		['%' + text + '%']
	)

	for (var j = 0; j < rows.length; j++) {
		data.options.push(optionFromRow(name, rows[j]))
	}

	return data
}

function filterCategories(user, params) {
	return modelFilter('category', user, params, true)
}

function filterArtists(user, params) {
	return modelFilter('artist', user, params, false)
}

function filterMechanics(user, params) {
	return modelFilter('mechanic', user, params, true)
}

function filterDesigners(user, params) {
	return modelFilter('designer', user, params, false)
}

function filterPublishers(user, params) {
	return modelFilter('publisher', user, params, false)
}

function filterFamilies(user, params) {
	return modelFilter('family', user, params, false)
}

function filterGames(user, params) {
	return modelFilter('game', user, params, false)
}

function filterLanguages(user, params) {
	return modelFilter('language', user, params, true)
}

function filterTagFamilies(user, params) {
	var data = { options: [] }
	var sessionUser = params.sessionUserId ? User.with_id(params.sessionUserId) : null
	var visibility = sessionUser && user.get_id() === sessionUser.get_id() ? 0 : 1

	TagFamily.where([
		['user_id', '=', user.get_id()],
		['family_public', '>=', visibility]
	]).forEach(function(family) {
		data.options.push({
			value: parseInt(family.get_id(), 10) + '-' + normalise(family.get_name()),
			text: family.get_name()
		})
	})

	return data
}

function filterTags(user, params) {
	var data = { options: [] }
	var sessionUser = params.sessionUserId ? User.with_id(params.sessionUserId) : null
	var visibility = sessionUser && user.get_id() === sessionUser.get_id() ? 0 : 1

	Tag.where([
		['user_id', '=', user.get_id()],
		['tag_public', '>=', visibility]
	]).forEach(function(tag) {
		var subtext = false

		if (tag.get_family_id()) {
			var family = TagFamily.with_id(tag.get_family_id())
			subtext = family ? family.get_name() : false
		}

		data.options.push({
			value: parseInt(tag.get_id(), 10) + '-' + normalise(tag.get_text()),
			text: tag.get_text(),
			subtext: subtext,
			colour: tag.get_colour()
		})
	})

	return data
}

function filterInventoryLocation(user) {
	var data = { options: [] }
	var rawLocations = Object.keys(Collection.indexed('collection_private_location', {
		where: [
			['user_id', '=', user.get_id()],
			['collection_private_location', '<>', '']
		]
	}))

	data.options = cleanSet(rawLocations)
	return data
}

function filterPlayLocation(user) {
	var data = { options: [] }
	var rawLocations = Object.keys(Play.indexed('play_location', {
		where: [
			['user_id', '=', user.get_id()],
			['play_location', '<>', '']
		]
	}))

	data.options = cleanSet(rawLocations)
	return data
}

function filterPlayedWith(user) {
	var data = { options: [] }
	var playIndex = Object.keys(Play.indexed('play_id', {
		where: [
			['user_id', '=', user.get_id()]
		]
	})).map(function(id) {
		return parseInt(id, 10)
	}).filter(Boolean)

	if (!playIndex.length) return data

	var rawPlayers = Object.keys(Player.indexed('player_name', {
		where: [
			['play_id', 'in', playIndex],
			['user_id', '<>', user.get_id()],
			['player_name', '<>', '']
		]
	}))

	data.options = cleanSet(rawPlayers)
	return data
}

var FILTERS = {
	categories: filterCategories,
	artists: filterArtists,
	mechanics: filterMechanics,
	designers: filterDesigners,
	publishers: filterPublishers,
	families: filterFamilies,
	games: filterGames,
	languages: filterLanguages,
	tag_families: filterTagFamilies,
	tags: filterTags,
	inventory_location: filterInventoryLocation,
	play_location: filterPlayLocation,
	played_with: filterPlayedWith
}

export default function(params) {
	var user = resolveOwner(params, F.OWNER_USER)
	if (!user) {
		return Promise.reject({ error: 'Owner not found in offline database', offline: true })
	}

	var handler = FILTERS[params.type]
	if (!handler) {
		return Promise.reject({ error: 'Invalid filter type', offline: true })
	}

	return Promise.resolve({
		session: { offline: true },
		data: handler(user, params)
	})
}
